import Swiper from "swiper";
import { Pagination, EffectCreative, Keyboard, Mousewheel, Navigation, Thumbs, EffectFade, Autoplay, EffectCoverflow, Grid } from "swiper/modules";
/**
 * @param swiperInit
 */
export default function swiperInit() {
	new Swiper(".section-home-banner .swiper", {
		slidesPerView: 1,
		spaceBetween: 0,
		speed: 1000,
		loop: true,
		autoplay: {
			delay: 3500,
		},
		modules: [Pagination, Navigation, Autoplay],
		pagination: {
			el: ".section-home-banner .swiper-pagination",
			clickable: true,
		},
		navigation: {
			nextEl: ".section-home-banner .btn-next",
			prevEl: ".section-home-banner .btn-prev",
		},
	});
	new Swiper(".section-common-uses .swiper", {
		slidesPerView: 1.2,
		spaceBetween: 15,
		speed: 1000,
		modules: [Pagination, Navigation, Grid],
		pagination: {
			el: ".section-common-uses .swiper-pagination",
			clickable: true,
		},
		navigation: {
			nextEl: ".section-common-uses .btn-next",
			prevEl: ".section-common-uses .btn-prev",
		},
		breakpoints: {
			768: {
				slidesPerView: 2,
				spaceBetween: 15,
				grid: {
					rows: 2,
					fill: "row",
				},
			},
			1024: {
				slidesPerView: 3,
				spaceBetween: 15,
				grid: {
					rows: 2,
					fill: "row",
				},
			},
			1200: {
				slidesPerView: 3,
				spaceBetween: 15,
				grid: {
					rows: 2,
					fill: "row",
				},
			},
			1300: {
				slidesPerView: 3,
				spaceBetween: 32,
				grid: {
					rows: 2,
					fill: "row",
				},
			},
		},
	});
	$(".swiper-loop-3").each(function (index) {
		const nameItem = "slide-loop-3-" + index;
		$(this).addClass(nameItem);
		new Swiper("." + nameItem + " .swiper", {
			modules: [Pagination, Navigation, Autoplay],
			observeParents: true,
			slidesPerView: 1,
			spaceBetween: 15,
			observer: true,
			navigation: {
				nextEl: `.${nameItem} .btn-next`,
				prevEl: `.${nameItem} .btn-prev`,
			},
			breakpoints: {
				768: {
					slidesPerView: 2,
					spaceBetween: 15,
				},
				1024: {
					slidesPerView: 3,
					spaceBetween: 15,
				},
				1200: {
					slidesPerView: 3,
					spaceBetween: 40,
				},
			},
		});
	});
}
